import { DataGridPremium } from "@mui/x-data-grid-premium";
import { useContractors } from "../../redux/contractor/contractorHooks";
import { setFormOpen, setSelectedContractorIDs } from "../../reducers/rhapsody";
import { useDispatch } from "react-redux";
import { Tooltip } from "@mui/joy";
import { Box } from "@mui/material";
import { RouterConfig } from "../config/routerConfig";
import { useNavigate } from "react-router-dom";

/**
 *
 * @returns {ReactElement} ContractorsDatagrid page
 */
export function ContractorsDatagrid() {
  const { contractors } = useContractors();
  const navigate = useNavigate();
  return (
    <DataGridPremium
      rows={contractors ?? []}
      onRowClick={(p) => {
        navigate(
          `${RouterConfig.contractors}/${p.row.id}?sourceID=${p.row.sourceID}&sourceRecordID=${p.row.sourceRecordID}&id=${p.row.id}`
        );
      }}
      columns={[
        {
          field: "sourceID",
          headerName: "",
          width: 12,
          renderCell: (p) =>
            p.value !== 420 ? (
              <Tooltip
                arrow
                size="sm"
                sx={{ maxWidth: 150, textAlign: "center" }}
                variant="outlined"
                title="Thie item cannot be edited. It is controlled by an organization using Rhapsody."
              >
                <i className="fa-solid fa-lock"></i>
              </Tooltip>
            ) : (
              <Box />
            ),
        },
        { field: "name", headerName: "Name", width: 200 },
        {
          field: "coverURL",
          headerName: "Cover",
          flex: 1,
          renderCell: (c) => {
            const contractor = c.row;
            return (
              <Box
                sx={{
                  background: c.row.color,
                  p: "4px",
                  borderRadius: "8px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <img
                  src={contractor.coverURL}
                  height={25}
                  style={{ borderRadius: 8 }}
                />
              </Box>
            );
          },
        },
      ]}
    />
  );
}
